// extracted by mini-css-extract-plugin
export default {"title":"Title__title__oYt6t"};